const HEADING_CLASSES = {
  H1: 'text-heading-md',
  H2: 'text-heading',
  H3: 'text-subheading',
};

function getHeadingClasses(headingSize) {
  return HEADING_CLASSES[headingSize] || HEADING_CLASSES.H2;
}

export { getHeadingClasses };
